import * as React from 'react';

const FallbackSVG: React.FC<React.HTMLAttributes<SVGElement>> = props => (
  <svg viewBox="0 0 24 24" version="1.1" {...props}>
    <title>Icons / TechCo / Light / Avatar Copy</title>
    <g
      id="Icons-/-TechCo-/-Light-/-Avatar-Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M18.7397222,18.834 C17.3453333,16.5480496 14.85,15.0152058 12,15.0152058 C9.15,15.0152058 6.65361111,16.5480496 5.25922222,18.834 C3.55555556,17.1008959 2.5,14.7169457 2.5,12.0858658 C2.5,6.79920595 6.76022222,2.5 12,2.5 C17.2387222,2.5 21.5,6.79920595 21.5,12.0858658 C21.5,14.7169457 20.4444444,17.1008959 18.7397222,18.834 M6.7733,19.4748632 L6.7733,19.4748632 C7.8033,17.5517053 9.7583,16.2496 12.0003,16.2496 C14.2413,16.2496 16.1973,17.5517053 17.2263,19.4748632 C15.7513,20.5874947 13.9493,21.2496 12.0003,21.2496 C10.0503,21.2496 8.2483,20.5874947 6.7733,19.4748632 M12.0003,1.0006 C5.9333,1.0006 1.0003,5.9336 1.0003,11.9996 C1.0003,18.0656 5.9333,22.9996 12.0003,22.9996 C18.0663,22.9996 23.0003,18.0656 23.0003,11.9996 C23.0003,5.9336 18.0663,1.0006 12.0003,1.0006"
        id="Fill-1"
        fill="#053362"
      ></path>
      <path
        d="M11.875,13.2496 C10.014,13.2496 8.5,11.7356 8.5,9.8746 C8.5,9.5836 8.549,9.3076 8.618,9.0366 C9.961,10.0666 11.605,10.6186 13.271,10.6186 C13.918,10.6186 14.565,10.5266 15.201,10.3596 C14.963,11.9896 13.57,13.2496 11.875,13.2496 M11.875,6.4996 C13.37,6.4996 14.625,7.4826 15.068,8.8316 C13.091,9.4436 10.918,9.0096 9.333,7.6806 C9.952,6.9626 10.856,6.4996 11.875,6.4996 M16.675,9.1386 C16.317,6.8016 14.311,4.9996 11.875,4.9996 C10.119,4.9996 8.59,5.9416 7.731,7.3386 C7.682,7.4056 7.641,7.4756 7.616,7.5526 C7.236,8.2456 7,9.0296 7,9.8746 C7,12.5626 9.187,14.7496 11.875,14.7496 C14.563,14.7496 16.75,12.5626 16.75,9.8746 C16.75,9.7046 16.717,9.5426 16.7,9.3776 C16.707,9.2976 16.695,9.2196 16.675,9.1386"
        id="Fill-4"
        fill="#053362"
      ></path>
    </g>
  </svg>
);

export default FallbackSVG;
